// Images for the Czech landing. Gallery pages are real pages of the Czech PDF, hosted in the store's Resources (Impultienda).
export interface GalleryItem {
  title: string
  caption: string
  image: string
}

const resource = (file: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e36c11fb-f00a-479b-b9d2-44c2768e2d9c/${file}`

export const gallery: GalleryItem[] = [
  {
    title: 'Dřep s činkou na zádech',
    caption:
      'Hlavní svaly, stabilizátory, anatomická rovina a nejčastější chyby – vše na jedné mapě.',
    image: resource('1792988357526_lamina-1.webp'),
  },
  {
    title: 'Bulharský dřep',
    caption: 'Jednostranná práce: co stabilizuje, co kompenzuje a jak to opravit.',
    image: resource('1792988359971_lamina-3.webp'),
  },
  {
    title: 'Tlak s činkou na šikmé lavici',
    caption: 'Klíční část velkého prsního svalu, rotátorová manžeta a správná dráha osy.',
    image: resource('1792988362382_lamina-17.webp'),
  },
  {
    title: 'Rozpažování na spodních kladkách',
    caption: 'Horizontální addukce v rameni a kontrola napětí prsního svalu.',
    image: resource('1792988364213_lamina-26.webp'),
  },
  {
    title: 'Přítahy velké činky v předklonu',
    caption: 'Retrakce lopatek, zadní řetězec a proč švihání tělem kazí cvik.',
    image: resource('1792988365832_lamina-21.webp'),
  },
]

// Czech mockup approved on 26/10/2026 (MOCKUP_CZ in ~/negocio/100-mapas-cz).
export const heroImage = resource('1792988353805_mockup-cz.webp')
